import { render, staticRenderFns } from "./ExtratoPJ.vue?vue&type=template&id=48485018"
import script from "./ExtratoPJ.vue?vue&type=script&lang=js"
export * from "./ExtratoPJ.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports